<template>
  <div>

    <Form :validation-schema="schema" @submit="handleRegister">

      <div class="candidature-body"/>
      <CandidatureHeader></CandidatureHeader>
      <CandidatureSteps :level=2></CandidatureSteps>
      <div v-if="status === ''" class="candidature-alert"><b>Attention :</b> votre dossier de candidature sera enregistré seulement à l'étape 3.</div>

      <div class="candidature-group">
        <h1><img alt="STAGE D'IMMERSION PROFESSIONNELLE" src="@/assets/img/underline.png">MON IMMERSION EN CLINIQUE DE 70 HEURES</h1>

        <div class="candidature-info">
          Vous devez avoir une expérience dans une clinique vétérinaire (hors animalerie, SPA ...) de deux semaines minimum (c'est-à-dire un stage de deux semaines consécutives ou deux stages d'une semaine ).
        </div>


        <Stage
            v-if="null !== stage1"
            ref="stage1"
            :index="1"
            :trainingcheck="trainingcheck"
            :attestationName="attestationName"
            :attestationUrl="attestationUrl"
            :debutDate="stage1.debutDate"
            :endDate="stage1.endDate"
            :duration="stage1.duration"
            :nameVeterinaryStructure="stage1.nameVeterinaryStructure"
            :activityVeterinaryStructure="stage1.activityVeterinaryStructure"
            :phoneNumberVeterinaryStructure="stage1.phoneNumberVeterinaryStructure"
            @update:debutDate="handleEventUpdate('stage1.debutDate', $event)"
            @update:endDate="handleEventUpdate('stage1.endDate', $event)"
            @update:duration="handleEventUpdate('stage1.duration', $event)"
            @update:nameVeterinaryStructure="handleEventUpdate('stage1.nameVeterinaryStructure', $event)"
            @update:activityVeterinaryStructure="handleEventUpdate('stage1.activityVeterinaryStructure', $event)"
            @update:phoneNumberVeterinaryStructure="handleEventUpdate('stage1.phoneNumberVeterinaryStructure', $event)"
            @update:fileCheck="trainingcheck = $event"
        />

        <Experience
            v-if="null !== stage2"
            :removable="true"
            ref="stage2"
            :index="2"
            @callRemove="removeStage"
            moduleType="Stage"
            :trainingcheck="trainingcheck2"
            :attestationName="attestationName2"
            :attestationUrl="attestationUrl2"
            label="Stage secondaire"
            type="Stage"
            :year="stage2.year"
            :name="stage2.name"
            :department="stage2.department"
            :duration="stage2.duration"
            :attestation="stage2.attestation"
            @update:year="handleEventUpdate('stage2.year', $event)"
            @update:name="handleEventUpdate('stage2.name', $event)"
            @update:department="handleEventUpdate('stage2.department', $event)"
            @update:type="handleEventUpdate('stage2.type', $event)"
            @update:duration="handleEventUpdate('stage2.duration', $event)"
            @update:fileCheck="trainingcheck2 = $event"
        />

        <div v-if="null === stage2" class="candidature-group">
          <h1><img alt="STAGE D'IMMERSION PROFESSIONNELLE" src="@/assets/img/underline.png">Stage secondaire
            <span class="candidature-button-content" @click="addStage2" style="cursor:pointer; float: right">
            <span class="candidature-button-content-label">Ajouter</span>
            <span class="candidature-button-icon"><img src="@/assets/img/plus.png" style="width: 25px;height: 25px" alt="Ajouter"/></span>
          </span>
          </h1>
        </div>

        <Experience
            v-if="null !== stage3"
            :removable="true"
            ref="stage3"
            :index="3"
            @callRemove="removeStage"
            moduleType="Stage"
            :trainingcheck="trainingcheck3"
            :attestationName="attestationName3"
            :attestationUrl="attestationUrl3"
            label="Stage secondaire"
            type="Stage"
            :year="stage3.year"
            :name="stage3.name"
            :department="stage3.department"
            :duration="stage3.duration"
            :attestation="stage3.attestation"
            @update:year="handleEventUpdate('stage3.year', $event)"
            @update:name="handleEventUpdate('stage3.name', $event)"
            @update:department="handleEventUpdate('stage3.department', $event)"
            @update:type="handleEventUpdate('stage3.type', $event)"
            @update:duration="handleEventUpdate('stage3.duration', $event)"
            @update:fileCheck="trainingcheck3 = $event"
        />

        <div v-if="null !== stage2 && null === stage3" class="candidature-group">
          <h1><img alt="STAGE D'IMMERSION PROFESSIONNELLE" src="@/assets/img/underline.png">Stage complémentaire
            <span class="candidature-button-content" @click="addStage3" style="cursor:pointer; float: right">
            <span class="candidature-button-content-label">Ajouter</span>
            <span class="candidature-button-icon"><img src="@/assets/img/plus.png" style="width: 25px;height: 25px" alt="Ajouter"/></span>
          </span>
          </h1>
        </div>

      </div>


      <div class="candidature-group">
        <h1><img src="@/assets/img/underline.png"> AUTRES EXPÉRIENCES PROFESSIONNELLES </h1>

        <div class="candidature-info">
          Vos deux dernières expériences professionnelles en poste (CDD, CDI, Stages,...)
        </div>

        <div class="candidature-group-sub">
          <div class="candidature-condition candidature-condition-col row">
            <label id="situation-anchor" class="candidature-condition-text" for="professionalSituation">Situation professionnelle*</label>
            <Field :model-value="professionalSituation"
                   @update:model-value="professionalSituation = $event"
                   as="select"
                   class="form-control"
                   name="professionalSituation" >
              <option disabled value=""></option>
              <option value="120746">Contrat d'apprentissage</option>
              <option value="120747">Contrat de professionnalisation</option>
              <option value="3734900">En formation, au CFA, sans contrat, suite à rupture</option>
              <option value="928626">Etudiant</option>
              <option value="928633">Inactif</option>
              <option value="928624">Jeune bénéficiaire du CIVIS</option>
              <option value="120753">Parcours d'initiation aux métiers</option>
              <option value="928632">Personne à la recherche d'un emploi</option>
              <option value="928631">Salarié (y compris intérimaires et salariés à temps partiel</option>
              <option value="928629">Salarié en contrat aidé : CUI-CIE, CUI-CAE</option>
              <option value="928623">Scolaire</option>
              <option value="928630">Stagiaire de la formation professionnelle</option>
            </Field>
            <ErrorMessage class="error-feedback" name="professionalSituation"/>
          </div>
        </div>
        <div class="candidature-group-sub">
          <div class="candidature-condition candidature-condition-col">
            <div class="candidature-condition-text">Avez-vous connu une expérience professionnelle en poste ?</div>
            <div class="custom-control custom-switch">
              <input id="switchWorkExperience" :checked="switchWorkExperience" @change="switchWorkExperience = $event.target.checked" class="custom-control-input" type="checkbox">
              <label class="custom-control-label" for="switchWorkExperience"></label>
            </div>
          </div>

          <div v-if="ifWorkExperience">
            <div class="candidature-condition candidature-condition-col row">
              <div class="candidature-condition-text">Dernier emploi occupé*</div>
              <Field :value="lastWork" @input="lastWork = $event.target.value" class="form-control" name="lastWork" type="text"/>
              <ErrorMessage class="error-feedback" name="lastWork"/>
            </div>
          </div>
        </div>

        <Experience
            v-if="ifWorkExperience"
            ref="experienceMain"
            :index="1"
            label="Expérience"
            moduleType="Experience"
            :year="experienceMain.year"
            :name="experienceMain.name"
            :department="experienceMain.department"
            :type="experienceMain.type"
            :duration="experienceMain.duration"
            @update:year="handleEventUpdate('experienceMain.year', $event)"
            @update:name="handleEventUpdate('experienceMain.name', $event)"
            @update:department="handleEventUpdate('experienceMain.department', $event)"
            @update:type="handleEventUpdate('experienceMain.type', $event)"
            @update:duration="handleEventUpdate('experienceMain.duration', $event)"
        />

      </div>

      <div id="cvcheck-anchor" class="candidature-group">
        <h1><img src="@/assets/img/underline.png"> CURRICULUM VITAE (CV) </h1>

        <label class="candidature-condition" for="cv">
          <input id="cv" :name="cv" accept="application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document" class="candidature-input-file" type="file" @change="filesChange($event.target.name, $event.target.files , 'cvA'); fileCount = $event.target.files.length">
          <div class="candidature-button">
            <div class="candidature-button-content">
              <div>
                <div v-if="cvcheck" class="candidature-button-icon"><img src="@/assets/img/check.png"></div>
                <div v-else class="candidature-button-icon"><img src="@/assets/img/plus.png"></div>
              </div>
              <div class="candidature-button-content-label">CV<br><a id="cvA" :href="cvUrl" target=”_blank”>{{ cvName }}</a></div>
            </div>
          </div>
        </label>
        <Field id="cvcheck" ref="cvcheck" :value="cvcheck" @input="cvcheck = $event.target.value" class="form-control" name="cvcheck" placeholder="" style="visibility:hidden; height:0;" type="text"/>
        <ErrorMessage class="error-feedback" name="cvcheck"/>
      </div>

      <div class="candidature-group">
        <h1><img src="@/assets/img/underline.png"> LETTRE DE MOTIVATION </h1>

        <div class="candidature-condition row">
                <textarea
                    :value="textarea"
                    @input="textarea = $event.target.value"
                    class="form-control"
                    placeholder="Veuillez saisir votre lettre de motivation directement dans ce champ ... "
                    rows="10"
                    spellcheck="false"
                />
        </div>
      </div>

      <div class="candidature-group">
        <h1><img src="@/assets/img/underline.png"> AUTORISATION DE DIFFUSION </h1>

        <div class="candidature-condition candidature-condition-col">
          <div class="candidature-condition-text">J’autorise la diffusion de mon dossier de candidature et mes coordonnées par APFORM aux employeurs vétérinaires à la recherche d’apprentis ASV sur la CV-theque.</div>
          <div class="custom-control custom-switch">
            <input id="switchIfDiffusion" :checked="switchIfDiffusion" @change="switchIfDiffusion = $event.target.checked" class="custom-control-input" type="checkbox">
            <label class="custom-control-label" for="switchIfDiffusion"></label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <button class="btn btn-primary btn-block" @click="handleClickValidation">
                <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
          {{ submitText }}
        </button>
      </div>

    </Form>

  </div>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";

import CandidatureHeader from '@/components/Candidature/Header.vue'
import CandidatureSteps from '@/components/Candidature/Steps.vue'
import UserService from "@/services/user.service";
import {simulateNewfiles} from "@/services/fake-href.service";
import Stage from "@/components/Candidature/Stage.vue";
import Experience from "@/components/Candidature/Experience.vue";
import Toast from "@/_helpers/AlerteHelper";

const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: "ParcoursProfessionnel",
  components: {
    Stage,
    Experience,
    Form,
    Field,
    ErrorMessage,
    CandidatureHeader,
    CandidatureSteps,
  },
  data() {
    return {
      successful: false,
      loading: false,
      message: "",
      isSubmitted: false,
      submitText: 'Étape suivante',
      textarea: '',
      status: '',
      addStage: false,
      addExperience: false,
      list: [],
      listFiltered: [],
      search: "",
      switchWorkExperience: false,
      switchIfDiffusion: true,

      stage1: null,
      stage2: null,
      stage3: null,

      experienceMain: null,

      professionalSituation: null,
      lastWork: '',


      cv: 'cv',
      trainingCertificate: 'trainingCertificate',
      trainingMedia1: null,
      trainingMedia2: null,
      trainingMedia3: null,
      FILECV: null,
      CVFIELDNAME: null,
      CVID: null,
      cvUrl: '',
      cvName: '',
      cvcheck: false,

      attestationUrl: '',
      attestationName: '',
      trainingcheck: false,

      attestationUrl2: '',
      attestationName2: '',
      trainingcheck2: false,


      attestationUrl3: '',
      attestationName3: '',
      trainingcheck3: false,


    }
  },
  mounted() {
    UserService.getCandidacyByUser().then(
        (response) => {
          this.candidacy = response.data

          if (response.data.stages[0]) {
            this.stage1 = response.data.stages[0];
          } else {
            this.stage1 = {
              debutDate: '',
              endDate: '',
              duration: '',
              nameVeterinaryStructure: '',
              activityVeterinaryStructure: '',
              phoneNumberVeterinaryStructure: '',
            }
          }

          this.experienceMain = {
            year: '',
            name: '',
            department: '',
            type: '',
            duration: ''
          }

          for (let i = 0; i < response.data.professional_experiences.length; i++) {

            if ("Stage" === response.data.professional_experiences[i].type) {
              if (null === this.stage2) {
                this.stage2 = response.data.professional_experiences[i];
                this.stage2.name = this.stage2.name.replace(/^#2 /, '');
                continue;
              }
              if (null === this.stage3) {
                this.stage3 = response.data.professional_experiences[i];
                this.stage3.name = this.stage3.name.replace(/^#3 /, '');
                continue;
              }
            }

            if (response.data.professional_experiences[i].type) {
              this.experienceMain = response.data.professional_experiences[i];
            }
          }


          this.professionalSituation = response.data.professional_situation
          this.lastWork = response.data.last_job


          this.switchWorkExperience = response.data.is_at_work
          this.switchIfDiffusion = response.data.if_diffusion
          this.textarea = response.data.letter
          this.status = response.status;

          let urlCV = '';
          let nameCV = '';
          let urlAttestation = '';
          let attestationName = '';

          let urlAttestation2 = '';
          let attestationName2 = '';


          let urlAttestation3 = '';
          let attestationName3 = '';

          if (response.data.medias.length > 0) {
            let mediaCV = response.data.medias.find(function (media, index) {
              if (media.typeOfMedia === "CV") {
                return media;
              }
            });
            urlCV = (mediaCV === undefined) ? '' : mediaCV.toBeTransferred ? API_URL + mediaCV.filePath : mediaCV.fileLink;
            nameCV = (mediaCV !== undefined) ? mediaCV.niceFileName : '';
            this.cvcheck = urlCV.length > 0;

            let mediaAttestation = response.data.medias.find(function (media, index) {
              if (media.typeOfMedia === "TRAININGCERTIFICATE") {
                return media;
              }
            });
            urlAttestation = (mediaAttestation === undefined) ? '' : mediaAttestation.toBeTransferred ? API_URL + mediaAttestation.filePath : mediaAttestation.fileLink;
            attestationName = (mediaAttestation !== undefined) ? mediaAttestation.niceFileName : '';
            this.trainingcheck = urlAttestation.length > 0;


            var mediaAttestation2 = response.data.medias.find(function (media, index) {
              if (media.typeOfMedia === "TRAININGCERTIFICATE2") {
                return media;
              }
            });
            urlAttestation2 = (mediaAttestation2 === undefined) ? '' : mediaAttestation2.toBeTransferred ? API_URL + mediaAttestation2.filePath : mediaAttestation2.fileLink;
            attestationName2 = (mediaAttestation2 !== undefined) ? mediaAttestation2.niceFileName : '';
            this.trainingcheck2 = null !== this.stage2 && urlAttestation2.length > 0;


            var mediaAttestation3 = response.data.medias.find(function (media, index) {
              if (media.typeOfMedia === "TRAININGCERTIFICATE3") {
                return media;
              }
            });
            urlAttestation3 = (mediaAttestation3 === undefined) ? '' : mediaAttestation3.toBeTransferred ? API_URL + mediaAttestation3.filePath : mediaAttestation3.fileLink;
            attestationName3 = (mediaAttestation3 !== undefined) ? mediaAttestation3.niceFileName : '';
            this.trainingcheck3 = null !== this.stage3 && urlAttestation3.length > 0;


          }
          this.cvUrl = urlCV.length > 0 ? urlCV : null
          this.cvName = (nameCV !== null) ? nameCV : null
          this.attestationUrl = urlAttestation.length > 0 ? urlAttestation : null
          this.attestationName = (attestationName !== null) ? attestationName : null

          this.attestationUrl2 = null !== this.stage2 && urlAttestation2.length > 0 ? urlAttestation2 : null
          this.attestationName2 = null !== this.stage2 && (attestationName2 !== null) ? attestationName2 : null

          this.attestationUrl3 = null !== this.stage3 && urlAttestation3.length > 0 ? urlAttestation3 : null
          this.attestationName3 = null !== this.stage3 && (attestationName3 !== null) ? attestationName3 : null

        },
    );
  },
  methods: {

    removeStage(index) {
      if (index === 2) {
        this.stage2 = null;
        this.attestationUrl2 = null;
        this.attestationName2 = null;
        this.trainingcheck2 = false;
      }
      if (index === 3) {
        this.stage3 = null;
        this.attestationUrl3 = null;
        this.attestationName3 = null;
        this.trainingcheck3 = false;
        this.$refs['stage2'].setRemovable(true);
      }
    },

    handleEventUpdate(field, value) {
      // Gérer à la fois les événements DOM et les valeurs directes
      const actualValue = value && value.target ? value.target.value : value;

      if (field.startsWith('stage1.')) {
        const fieldName = field.replace('stage1.', '');
        this.stage1[fieldName] = actualValue;
      } else if (field.startsWith('stage2.')) {
        const fieldName = field.replace('stage2.', '');
        this.stage2[fieldName] = actualValue;
      } else if (field.startsWith('stage3.')) {
        const fieldName = field.replace('stage3.', '');
        this.stage3[fieldName] = actualValue;
      } else if (field.startsWith('experienceMain.')) {
        const fieldName = field.replace('experienceMain.', '');
        this.experienceMain[fieldName] = actualValue;
      } else {
        this[field] = actualValue;
      }
    },


    addStage2() {
      this.stage2 = {
        year: '',
        name: '',
        department: '',
        type: 'Stage',
        duration: '',
        attestation: ''
      }

    },
    addStage3() {
      this.stage3 = {
        year: '',
        name: '',
        department: '',
        type: 'Stage',
        duration: '',
        attestation: ''
      }
      this.$refs['stage2'].setRemovable(false);
    },


    handleRegister(data) {


      this.message = "";
      this.successful = false;


      let expectedModuleValidCount = 1;
      if (null !== this.stage2) {
        expectedModuleValidCount++;
      }
      if (null !== this.stage3) {
        expectedModuleValidCount++;
      }
      if (this.ifWorkExperience) {
        expectedModuleValidCount++;
      }

      let moduleValidCount = 0;
      data.stages = [];
      this.$refs['stage1'].$refs.form.validate().then(status => {
        if (status.valid) {
          moduleValidCount++;
          data.stages.push({
            debutDate: this.stage1.debutDate,
            endDate: this.stage1.endDate,
            duration: this.stage1.duration,
            nameVeterinaryStructure: this.stage1.nameVeterinaryStructure,
            activityVeterinaryStructure: this.stage1.activityVeterinaryStructure,
            phoneNumberVeterinaryStructure: this.stage1.phoneNumberVeterinaryStructure,
          });
          if (this.$refs['stage1'].fileList.length > 0) {
            const formDataTraining = new FormData();
            Array
                .from(Array(this.$refs['stage1'].fileList.length).keys())
                .map(x => {
                  formDataTraining.append('file', this.$refs['stage1'].fileList[x], this.$refs['stage1'].fileList[x].name);
                });
            data.trainingMedia1 = formDataTraining;
          }


        } else {
          moduleValidCount = 0;

        }

        let valid = moduleValidCount === expectedModuleValidCount;
        this.register(data, valid);
      })

      data.experiences = [];

      if (true === this.ifWorkExperience) {
        this.$refs['experienceMain'].$refs.form.validate().then(status => {
          if (status.valid) {
            moduleValidCount++;
            data.experiences.push({
              year: this.experienceMain.year,
              name: this.experienceMain.name,
              department: this.experienceMain.department,
              type: this.experienceMain.type,
              duration: this.experienceMain.duration,
            });
          } else {
            moduleValidCount = 0;
          }

          let valid = moduleValidCount === expectedModuleValidCount;
          this.register(data, valid);
        })
      }

      if (null !== this.stage2) {
        this.$refs['stage2'].$refs.form.validate().then(status => {
          if (status.valid) {
            moduleValidCount++;


            data.experiences.push({
              year: this.stage2.year,
              name: this.stage2.name.indexOf('#2 ') !== 0 ? '#2 ' + this.stage2.name : this.stage2.name,
              department: this.stage2.department,
              type: this.stage2.type,
              duration: this.stage2.duration,
              attestation: this.stage2.attestation,

            });
            if (this.$refs['stage2'].fileList.length > 0) {
              const formDataTraining = new FormData();

              Array
                  .from(Array(this.$refs['stage2'].fileList.length).keys())
                  .map(x => {
                    formDataTraining.append('file', this.$refs['stage2'].fileList[x], this.$refs['stage2'].fileList[x].name);

                  });
              data.trainingMedia2 = formDataTraining;
            }

          } else {
            moduleValidCount = 0;
          }

          let valid = moduleValidCount === expectedModuleValidCount;
          this.register(data, valid);
        })
      }

      if (null !== this.stage3) {
        this.$refs['stage3'].$refs.form.validate().then(status => {
          if (status.valid) {
            moduleValidCount++;
            data.experiences.push({
              year: this.stage3.year,
              name: this.stage3.name.indexOf('#3 ') !== 0 ? '#3 ' + this.stage3.name : this.stage3.name,
              department: this.stage3.department,
              type: this.stage3.type,
              duration: this.stage3.duration,
              attestation: this.stage3.attestation,
            });
            if (this.$refs['stage3'].fileList.length > 0) {
              const formDataTraining = new FormData();
              Array
                  .from(Array(this.$refs['stage3'].fileList.length).keys())
                  .map(x => {
                    formDataTraining.append('file', this.$refs['stage3'].fileList[x], this.$refs['stage3'].fileList[x].name);

                  });
              data.trainingMedia3 = formDataTraining;
            }

          } else {
            moduleValidCount = 0;
          }

          let valid = moduleValidCount === expectedModuleValidCount;
          this.register(data, valid);
        })
      }


    },
    handleClickValidation() {
      this.isSubmitted = true;
    },


    register(data, valid) {

      if (false === valid) {
        this.submitText = "Votre formulaire contient des erreurs";
        let _current = this;
        window.setTimeout(function () {
          window.scrollTo(0, 0);
        }, 4000);

        window.setTimeout(function () {
          _current.submitText = "Étape suivante";
        }, 6000);
        return;
      }
      this.submitText = "Étape suivante";

      Toast(
          'success',
          'Préparation de votre candidature en cours, merci de patienter',
          'top-end',
          3000)

      this.loading = true;

      data.durationExperience1 = this.durationExperience1
      data.ifWorkExperience = this.switchWorkExperience
      data.ifDiffusion = this.switchIfDiffusion
      data.letter = this.textarea


      if (this.FILECV !== null) {
        const formDataCV = new FormData();
        Array
            .from(Array(this.FILECV.length).keys())
            .map(x => {
              formDataCV.append('file', this.FILECV[x], this.FILECV[x].name);
            });
        data.cvMedia = formDataCV;
      }


      UserService.saveCandidacyPartTwo(this.candidacy.id, data).then((valid) => {
            this.$router.push({name: 'ma-candidature-3'})
          }
      );
    },
    filesChange(fieldName, fileList, id) {
      if (!fileList.length) return;
      var allowedTypes = document.getElementById(fieldName).accept.split(',').map(type => `${type.trim()}`);
      if (!allowedTypes.includes(fileList[0].type)) {
        alert(`Le type de fichier n\'est pas autorisé`)
        return
      }
      if (fileList[0]['size'] > (8 * 1000 * 1024)) {
        alert('Le fichier ne doit pas être supérieur à 8Mo')
        return;
      }

      this.FILECV = fileList;
      this.CVFIELDNAME = fieldName;
      this.CVID = id;
      simulateNewfiles(fileList[0], id)
      this.cvcheck = true;

    },

  },
  computed: {
    ifWorkExperience: function () {
      return this.switchWorkExperience;
    },
    schema() {
      return yup.object().shape({
        cvcheck: yup
            .string()
            .required(true, "CV : Vous devez déposé un document"),
        professionalSituation: yup
            .string()
            .nullable(true)
            .required("Ce champ doit être renseigné"),
        lastWork: this.ifWorkExperience
            ? yup
                .string()
                .max(255, "Dernier emploi occupé : ce champ ne doit pas dépasser 255 caractères")
                .required("Ce champ doit être renseigné")
            : yup.mixed().notRequired()
      })
    }
  },
};
</script>
